import axios, { AxiosError, isAxiosError } from 'axios'


export const DATA_API_URL = '/patient'
export const DATA_LAB_TEST = '/labtest'
export const RESULT = '/result'

export type BasicResponse<T> = {
  data?: T[]
  error?: string
}

export type BasicResponseLab<T> = {
  data?: T[]
  error?: string

}
export type PatientData = {
  id: string
  full_name: string
}

export type LabTestData = {
  id: string
  full_name: string
  date: string
  order_number: number
  patient: string
  blanc_name: string
  file_name: string
  results: string
  blank_id: string
}
export type PatientDataResponse = BasicResponse<PatientData>
export type LabtestDataResponse = BasicResponseLab<LabTestData>


export const getAllPatient = async () => {
  try {
    const res = await axios.get(DATA_API_URL)
    if (res.status === 200) return { data: res.data.patient }
    else {
      if (isAxiosError(res)) return { error: (res as AxiosError).message }
      else return { error: 'Unknown error' }
    }
  }
  catch (error) {
    return { error: 'Request failed' };
  }
}

export const getUsername = async () => {
  try {
    const res = await axios.get(DATA_API_URL)
    if (res.status === 200) return { data: res.data.username }
    else {
      if (isAxiosError(res)) return { error: (res as AxiosError).message }
      else return { error: 'Unknown error' }
    }
  }
  catch (error) {
    return { error: 'Request failed' };
  }
}


let labTestDataLatestFetch = 0
export const getAllData = async (requestData?: any): Promise<PatientDataResponse> => {
  labTestDataLatestFetch = Date.now()
  const fetchTime = labTestDataLatestFetch
  let res = requestData ? await axios.post(DATA_LAB_TEST, requestData) : await axios.get(DATA_LAB_TEST)
  if (labTestDataLatestFetch !== fetchTime) return {}
  if (res.status === 200) {

    return { data: res.data.results };
  } else {
    if (isAxiosError(res)) {
      return { error: (res as AxiosError).message };
    } else {
      return { error: 'Unknown error' };
    }
  }
};


export const getPdf = async (pdfName?: any): Promise<PatientDataResponse> => {
  let res = pdfName ? await axios.post(RESULT, pdfName) : await axios.get(RESULT)
  if (res.status === 200) {
  if(res.data.report !== undefined){
    res.data.results = res.data.report
    return { data: res.data.results };
  }
  else{
    return { data: res.data.results };
  }
  } 

  else {
    if (isAxiosError(res)) {
      return { error: (res as AxiosError).message };
    } else {
      return { error: 'Unknown error' };
    }
  }
};
